module.exports = __webpack_public_path__ + "3e758c57cfebb41d86d9d4c42952e6b6.pdf";